// Twinned with src/template-keys.ts in nhs-spi-api
// Also ensure to update https://nhsd-confluence.digital.nhs.uk/spaces/Vacc/pages/1457457561/Campaign+templates+-+user+guide
// When keys are added/removed.
export const TEMPLATE_PROPERTY_KEYS = [
  'CampaignConfig.Type.input.display',
  'CampaignConfig.Type.input.default',
  'CampaignConfig.Type.input.hint',
  'CampaignConfig.Type.summary.display',
  'CampaignConfig.Target.input.default',
  'CampaignConfig.Target.input.display',
  'CampaignConfig.Target.summary.display',
  'CampaignConfig.Name.input.default',
  'CampaignConfig.StartDate.input.default',
  'CampaignConfig.StartDate.input.display',
  'CampaignConfig.StartDate.summary.display',
  'CampaignConfig.StartDate.header.display',
  'CampaignConfig.EndDate.input.default',
  'CampaignConfig.EndDate.input.display',
  'CampaignConfig.EndDate.summary.display',
  'CampaignConfig.EndDate.header.display',
  'CampaignConfig.Approver.input.default',
  'CampaignConfig.Approver.input.display',
  'CampaignConfig.Approver.summary.display',
  'CampaignConfig.Manager.input.default',
  'CampaignConfig.Manager.input.display',
  'CampaignConfig.Manager.summary.display',
  'CampaignConfig.Reviewer.input.default',
  'CampaignConfig.Reviewer.input.display',
  'CampaignConfig.Reviewer.summary.display',
  'CampaignConfig.AvailableRoutingIds.input.default',
  'CampaignConfig.AvailableRoutingIds.input.display',
  'IterationDetails.IterationCohorts.input.default',
  'IterationDetails.IterationCohorts.input.display',
  'IterationDetails.IterationRules.filters.input.default',
  'IterationDetails.IterationRules.filters.input.display',
  'IterationDetails.IterationRules.suppressions.input.default',
  'IterationDetails.IterationRules.suppressions.input.display',
  'IterationDetails.IterationRules.routing.input.default',
  'IterationDetails.IterationRules.routing.input.display',
] as const;

export const TODAY_DATE_TOKEN = '{TODAY_DATE}';

export type AllowedTemplateKeys = typeof TEMPLATE_PROPERTY_KEYS[number];

export type CampaignTemplate = Partial<Record<AllowedTemplateKeys, string>>;

export type TemplateProperty = { key: AllowedTemplateKeys; value: string };
